/// <amd-module name="SuiteCommerce.InventoryDisplay.Message.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.InventoryDisplay.Message.View", ["require", "exports", "Backbone", "SuiteCommerce.InventoryDisplay.InventoryDisplay.Configuration"], function (require, exports, Backbone_1, InventoryDisplay_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var InventoryDisplayMessageView = /** @class */ (function (_super) {
        __extends(InventoryDisplayMessageView, _super);
        function InventoryDisplayMessageView(options) {
            var _this = _super.call(this, options) || this;
            _this.messageTypes = {
                lowStock: 'low-stock',
                inStock: 'in-stock',
                alwaysInStock: 'always-in-stock',
                backOrder: 'back-order',
            };
            _this.item = InventoryDisplayMessageView.getItemInfo(options.pdp);
            _this.stockInfo = options.pdp.getStockInfo();
            _this.isloading = true;
            _this.pdp = options.pdp;
            _this.pdp.on('afterOptionSelection', function () {
                _this.item = InventoryDisplayMessageView.getItemInfo(options.pdp);
                _this.stockInfo = options.pdp.getStockInfo();
                _this.render();
            });
            return _this;
        }
        InventoryDisplayMessageView.getItemInfo = function (pdp) {
            var itemInfo;
            var selectedMatrixChilds = pdp.getSelectedMatrixChilds();
            if (selectedMatrixChilds.length === 1) {
                itemInfo = selectedMatrixChilds[0];
            }
            else {
                itemInfo = pdp.getItemInfo().item;
            }
            return itemInfo;
        };
        InventoryDisplayMessageView.prototype.getMessageType = function () {
            var messageType = this.messageTypes.inStock;
            if (this.isAlwaysInStockItem()) {
                messageType = this.messageTypes.alwaysInStock;
            }
            else if (this.isInStock() && this.isUnderThreshold()) {
                messageType = this.messageTypes.lowStock;
            }
            else if (!this.isInStock() && this.item.isbackorderable) {
                messageType = this.messageTypes.backOrder;
            }
            return messageType;
        };
        InventoryDisplayMessageView.prototype.getOrderType = function () {
            var messageClass = '';
            if (this.item.isdropshipitem) {
                messageClass = 'dropship';
            }
            else if (this.item.isspecialorderitem) {
                messageClass = 'special-order';
            }
            return messageClass;
        };
        InventoryDisplayMessageView.prototype.getQuantityAvailable = function () {
            return this.stockInfo.stock;
        };
        InventoryDisplayMessageView.prototype.loaded = function () {
            this.isloading = false;
            this.dropShipSpecialOrderItemsAlwaysInStock = this.model.get('dropShipSpecialOrderItemsAlwaysInStock');
            this.render();
        };
        InventoryDisplayMessageView.prototype.getContext = function () {
            var stockMessage = this.isEnabledMessagingForItem()
                && (this.isInStock() || this.isRequiredMessageByOutStockBehavior()) ? this.getStockMessage() : '';
            var quantityAvailableMessage = this.isEnabledShowQuantityForItem() ? this.getQuantityAvailableMessage() : '';
            var loadingText = 'Loading...';
            var messageType = this.getMessageType();
            var orderType = this.getOrderType();
            return {
                stockMessage: stockMessage,
                loadingText: loadingText,
                messageType: messageType,
                orderType: orderType,
                quantityAvailableMessage: quantityAvailableMessage,
                isLoading: this.isloading,
                isInStock: this.isInStock(),
                isBackorderable: this.item.isbackorderable,
                isJSONLdEnabled: InventoryDisplay_Configuration_1.InventoryDisplayConfiguration.isJSONLdEnabled
            };
        };
        InventoryDisplayMessageView.prototype.isAlwaysInStockItem = function () {
            return this.dropShipSpecialOrderItemsAlwaysInStock && (this.item.isdropshipitem ||
                this.item.isspecialorderitem);
        };
        InventoryDisplayMessageView.prototype.isEnabledMessagingForItem = function () {
            return !this.item.custitem_ns_sc_ext_id_hide_invt_msg;
        };
        InventoryDisplayMessageView.prototype.isShowQuantityUnderThresholdEnabled = function () {
            return this.item.custitem_ns_sc_ext_id_hide_low_qty_msg ||
                InventoryDisplay_Configuration_1.InventoryDisplayConfiguration.hideQuantityForLowStock;
        };
        InventoryDisplayMessageView.prototype.isUnderThreshold = function () {
            var selectedTreshold = this.item.custitem_ns_sc_ext_id_low_stock_thresh >= 0 ?
                this.item.custitem_ns_sc_ext_id_low_stock_thresh :
                InventoryDisplay_Configuration_1.InventoryDisplayConfiguration.lowStockThreshold;
            return selectedTreshold >= 0
                && (this.getQuantityAvailable() > 0)
                && (this.getQuantityAvailable() < selectedTreshold);
        };
        InventoryDisplayMessageView.prototype.isRequiredMessageByOutStockBehavior = function () {
            return this.item.outofstockbehavior === '- Default -'
                || this.item.outofstockbehavior === 'Allow back orders with no out-of-stock message'
                || this.item.outofstockbehavior === 'Allow back orders but display out-of-stock message';
        };
        InventoryDisplayMessageView.prototype.isEnabledShowQuantityForItem = function () {
            var isEnabled = !this.item.custitem_ns_sc_ext_id_hide_qty_avl;
            if (this.isUnderThreshold()) {
                isEnabled = !this.isShowQuantityUnderThresholdEnabled();
            }
            return isEnabled;
        };
        InventoryDisplayMessageView.prototype.getQuantityAvailableMessage = function () {
            var quantityAvailableMessage;
            var stockQuantity = this.getQuantityAvailable();
            if (stockQuantity === 0) {
                return '';
            }
            quantityAvailableMessage = this.item.custitem_ns_sc_ext_id_qty_avl_msg
                || InventoryDisplay_Configuration_1.InventoryDisplayConfiguration.quantityAvailableMessageForRegularItems;
            quantityAvailableMessage = this.replaceQuantityPlaceholder(quantityAvailableMessage);
            return quantityAvailableMessage;
        };
        InventoryDisplayMessageView.prototype.replaceQuantityPlaceholder = function (message) {
            var stockQuantity = this.getQuantityAvailable();
            return message.replace('[[quantity]]', "" + stockQuantity);
        };
        return InventoryDisplayMessageView;
    }(Backbone_1.View));
    exports.InventoryDisplayMessageView = InventoryDisplayMessageView;
});
